import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';


import { routes } from './app.routes';
import { FirebaseApp } from '@angular/fire/app';
import { initializeApp } from 'firebase/app';
import { Auth, getAuth } from '@angular/fire/auth';
import { Firestore, getFirestore } from '@angular/fire/firestore';
import { Storage, getStorage } from '@angular/fire/storage';

import { Functions, getFunctions } from '@angular/fire/functions';

// Import shared ConfigService from the main app
import { ConfigService } from '../../../../src/app/services/config.service';

let firebaseApp: FirebaseApp;

export function initializeAppFactory(configService: ConfigService): () => Promise<void> {
  return () => configService.loadAppConfig().then(config => {
    if (!firebaseApp) {
      firebaseApp = initializeApp(config.firebase) as unknown as FirebaseApp;
    }
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [ConfigService],
      multi: true
    },
    { provide: FirebaseApp, useFactory: () => firebaseApp },
    { provide: Auth, useFactory: () => getAuth(firebaseApp) },
    { provide: Firestore, useFactory: () => getFirestore(firebaseApp) },
    { provide: Storage, useFactory: () => getStorage(firebaseApp) },
    { provide: Functions, useFactory: () => getFunctions(firebaseApp, 'us-central1') }
  ]
};

